import DataController from './data.controller';
import ClockoutController from '../core/clockout.controller';

/**
 * External store adapter for React's useSyncExternalStore, backed by the
 * existing DataController singleton + ClockoutController._authSubscribers
 * pub/sub. No new state is introduced — this only exposes the session cache
 * (already populated from GET /api/user) in a form useScope() can subscribe to.
 */
let cachedSnapshot = null;
let cachedSource = null;

// `useSyncExternalStore` requires `getSnapshot` to return the same reference
// when nothing changed — a fresh `[]`/`{}` literal from `??` on every call
// looks like a change on every render and drives React into the "Maximum
// update depth exceeded" loop (forceStoreRerender firing forever). Module-
// level constants keep the no-session-yet case referentially stable.
const EMPTY_SCOPES = [];
const EMPTY_SCOPES_BY_ABA = {};

function computeSnapshot() {
    const scopes = DataController.Instance()?.user?.scopes ?? EMPTY_SCOPES;
    // Reference-stable unless the underlying array identity changes (a fresh
    // fetchUserByToken() response), so useSyncExternalStore doesn't re-render
    // needlessly on unrelated auth-subscriber notifications.
    if (cachedSource === scopes && cachedSnapshot) return cachedSnapshot;
    cachedSource = scopes;
    cachedSnapshot = scopes;
    return cachedSnapshot;
}

export function getScopesSnapshot() {
    return computeSnapshot();
}

export function getScopesByAbaSnapshot() {
    return DataController.Instance()?.user?.scopesByAba ?? EMPTY_SCOPES_BY_ABA;
}

export function subscribeToScopes(callback) {
    // Piggyback on the auth-subscriber notification channel: login, logout,
    // and any future "session refreshed" event all funnel through
    // ClockoutController._notifyAuthChange().
    const fauxSubscriber = { onAuthChange: callback };
    ClockoutController._authSubscribers.add(fauxSubscriber);
    return () => ClockoutController._authSubscribers.delete(fauxSubscriber);
}
